import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import Icon from '../../../../components/Icon';
import { handleFieldChange } from "../../../../Utils";

class FactorForm extends Component {
    constructor(props) {
        super(props);

        this.state = { factor: props.factor };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.onSubmit(this.state.factor);
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                    <div style={{ width: '80%'}}>
                        <FieldGroup
                            name="factor"
                            type="number"
                            min={0}
                            max={1}
                            step={0.01}
                            label="Factor:"
                            onChange={this.handleFieldChange}
                            value={this.state.factor || this.state.factor === 0 ? this.state.factor : this.props.factor}
                            required
                        />
                    </div>
                    <Button style={{ height: 'auto', marginLeft: 'auto'}} bsStyle="success" type="submit"><Icon name="floppy-o"/> Save</Button>
                </div>
            </form>
        );
    }
}

export default FactorForm;


// WEBPACK FOOTER //
// ./src/scenes/Filler/components/FactorForm/index.js